import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';
import css from './index.module.scss';

interface ItfItem {
    text: string;
    img: string;
}
const Tab4: React.FC = () => {
    const { t } = useLang('stream.overview');
    const items: ItfItem[] = [
        {
            text: t('E_item4_name1'),
            img: 'https://websiteoss.ecoflow.com/upload/image/1774594571532/LOGO.png',
        },
        {
            text: t('E_item4_name2'),
            img: 'https://websiteoss.ecoflow.com/upload/image/1774594570632/LOGO%20(1).png',
        },
        {
            text: t('E_item4_name3'),
            img: 'https://websiteoss.ecoflow.com/upload/image/1774594570401/LOGO%20(2).png',
        },
        {
            text: t('E_item4_name4'),
            img: 'https://websiteoss.ecoflow.com/upload/image/1774594570125/LOGO%20(3).png',
        },
        {
            text: t('E_item4_name5'),
            img: 'https://websiteoss.ecoflow.com/upload/image/1774594569901/LOGO%20(4).png',
        },
        {
            text: t('E_item4_name6'),
            img: 'https://websiteoss.ecoflow.com/upload/image/1774594569667/LOGO%20(5).png',
        },
        {
            text: t('E_item4_name7'),
            img: 'https://websiteoss.ecoflow.com/upload/image/1774594572037/LOGO%20(6).png',
        },
        {
            text: t('E_item4_name8'),
            img: 'https://websiteoss.ecoflow.com/upload/image/1774594571778/LOGO%20(7).png',
        },
    ];
    return (
        <div className={`${css.frag}`}>
            <p className="text">{t('E_item4_text')}</p>
            <ul className="items">
                {items?.map((item: ItfItem) => (
                    <li className="item" key={item.text}>
                        <EcoImg className="item-img" pc={item.img} alt={item.text} />
                        <p className="item-text">{item.text}</p>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default Tab4;
